import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  "data": {
    "enable": false,
    "deviceOffline": true,
    "deviceRegistration": false,
    "deviceFirmwareUpdate": true
  }
};

export const settingNotificationsSlice = createSlice({
  name: "settingNotifications",
  initialState,
  reducers: {
    updateSettingNotifications: (state, action) => {
      state.data = action.payload.data;
    },
  },
});

export const { updateSettingNotifications } = settingNotificationsSlice.actions;

export default settingNotificationsSlice.reducer;